import api from "./axiosConfig";

export async function getMyPhotos() {
  const response = await api.get("/api/photos/me");
  return response.data;
}

export async function uploadPhoto(file) {
  const presignResponse = await api.post("/api/photos/presign-upload", {
    fileName: file.name,
    contentType: file.type,
    fileSize: file.size
  });

  const presignData = presignResponse.data;

  const s3Response = await fetch(presignData.uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type
    },
    body: file
  });

  if (!s3Response.ok) {
    throw new Error(
      `Storage rejected the upload (HTTP ${s3Response.status}). Please try again later.`
    );
  }

  const completeResponse = await api.post("/api/photos/complete", {
    photoId: presignData.photoId,
    s3Key: presignData.s3Key,
    contentType: file.type,
    fileSize: file.size
  });

  return completeResponse.data;
}

export async function deletePhoto(photoId) {
  await api.delete(`/api/photos/${photoId}`);
}

export async function setMainPhoto(photoId) {
  const response = await api.put(`/api/photos/${photoId}/main`);
  return response.data;
}
